import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { useStmResetAllCarts } from '@cart-services/hooks/use-stm-reset-all-carts'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { Checkbox } from '@pets-ui/Checkbox/Checkbox'
import { HStack } from '@pets-ui/HStack/HStack'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { CloseSmall } from '@pets-ui/icons'
import { Paper } from '@pets-ui/Paper/Paper'
import { Popper } from '@pets-ui/Popper/Popper'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { zIndex } from '@pets-ui/tokens/zIndex.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useCallback, useState } from 'react'
import { useStmCart } from '../CartProvider'

const DESKTOP = '@media (min-width: 984px)'

const styles = stylex.create({
  popper: {
    zIndex: zIndex.tooltip,
  },
  arrow: {
    display: 'flex',
    justifyContent: {
      [DESKTOP]: 'center',
      default: 'flex-end',
    },
    paddingRight: {
      [DESKTOP]: 0,
      default: 28,
    },
    width: '100%',
  },
  arrowTriangle: {
    backgroundColor: colors.white,
    clipPath: 'polygon(0 0, 100% 0, 50% 100%)',
    height: 10,
    width: 20,
  },
})

interface PopConfirmDiscardCartProps {
  open: boolean
  anchorEl: HTMLElement | null
  onClose: () => void
}

export const PopConfirmDiscardCart = (props: PopConfirmDiscardCartProps) => {
  const { open, anchorEl, onClose } = props
  const { campaignId, platform } = useStmCart()
  const { resetCartValues } = useFpB2bCartService(campaignId, platform)
  const { resetAllCarts } = useStmResetAllCarts()
  const [discardAll, setDiscardAll] = useState(false)

  const handleClose = useCallback(() => {
    setDiscardAll(false)
    onClose()
  }, [onClose])

  const handleConfirm = () => {
    if (discardAll) {
      resetAllCarts()
    }
    else {
      resetCartValues()
    }
    handleClose()
  }

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="top"
      offset={[0, 4]}
      disablePortal
      {...stylex.props(styles.popper)}
    >
      <Box>
        <Paper elevation={4} p={3} maxWidth={204} position="relative">
          <VStack gap={3}>
            <VStack gap={3} alignItems="start" width="100%">
              <HStack flexWrap="nowrap">
                <Text color={colors.grey800}>
                  確定要刪除此品牌下的所有商品？
                </Text>
                <Box display="flex" alignItems="start">
                  <IconButton variant="text" onClick={handleClose}>
                    <CloseSmall fontSize={16} color={colors.grey600} />
                  </IconButton>
                </Box>
              </HStack>
              <Checkbox
                color="blue"
                checked={discardAll}
                onChange={e => setDiscardAll(e.target.checked)}
                label="一併刪除全品牌"
              />
            </VStack>
            <HStack gap={3} justifyContent="flex-end">
              <Button variant="outlined" color="grey" size="small" onClick={handleClose}>
                取消
              </Button>
              <Button color="red" size="small" onClick={handleConfirm}>
                確定
              </Button>
            </HStack>
          </VStack>
        </Paper>
        <Box rootStyle={styles.arrow}>
          <Box rootStyle={styles.arrowTriangle} />
        </Box>
      </Box>
    </Popper>
  )
}
